module.exports = __webpack_public_path__ + "static/media/gcdef_10046.6a14572a.ico";